"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _taggingHelper = require("@eig-builder/core-utils/helpers/tagging-helper");

var _Checkbox = _interopRequireDefault(require("@eig-builder/core-ui/Checkbox"));

var _InputLabel = _interopRequireDefault(require("@eig-builder/core-ui/InputLabel"));

var _moduleLocalization = _interopRequireDefault(require("@eig-builder/module-localization"));

require("../lang");

var renderFilterSelector = function renderFilterSelector(filterSelectorHeaders, filterSelectionClick, tag) {
  // Filtering this way will only work for boolean fields (for now). and it's not tested with more than one boolean field per table
  // 0 not checked, 1 is checked, 2 both are checked.
  // which means that 2 basically is no filter but it was decided that it has to work this. So when type is 2 there is code to translate it back to no filter.
  var returnItems = [];
  filterSelectorHeaders.forEach(function (item, index) {
    if (item.isFilterable) {
      returnItems.push( /*#__PURE__*/_react["default"].createElement("li", {
        key: index
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "filter-selector-container filter-selector-check-true",
        onClick: function onClick() {
          return filterSelectionClick(item, 1, ![1, 2].includes(item.filterType));
        }
      }, /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
        className: "filter-selector-check",
        tag: 'filter-selector-check-true-' + tag,
        dataElementLocation: _taggingHelper.DataElementLocations.BODY,
        dataElementLabel: 'filter-selector-check-true-' + tag,
        dataElementId: 'filter-selector-check-true-' + tag,
        color: "primary",
        checked: [1, 2].includes(item.filterType),
        disabled: item.isRequired
      }), /*#__PURE__*/_react["default"].createElement(_InputLabel["default"], null, item.title))));
      returnItems.push( /*#__PURE__*/_react["default"].createElement("li", {
        key: -index
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "filter-selector-container filter-selector-check-false",
        onClick: function onClick() {
          return filterSelectionClick(item, 0, [0, 2].includes(item.filterType));
        }
      }, /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
        className: "filter-selector-check",
        tag: 'filter-selector-check-true-' + tag,
        dataElementLocation: _taggingHelper.DataElementLocations.BODY,
        dataElementLabel: "filter-selector-check-false",
        dataElementId: 'filter-selector-check-false-' + tag,
        color: "primary",
        checked: [0, 2].includes(item.filterType),
        disabled: item.isRequired
      }), /*#__PURE__*/_react["default"].createElement(_InputLabel["default"], null, /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_moduleLocalization["default"], {
        message: "core.components.datatable.filter.not"
      }), " ", item.title)))));
    }
  });
  return returnItems;
};

var _default = renderFilterSelector;
exports["default"] = _default;